$(document).on('turbo:load', function() {
  $(document).on('change', '.advisors-road-funnel-component select[name=timeline]', function() {
    const timeline = $(this).val();
    const component = $(this).closest('.advisors-road-funnel-component');
    const hsCompanyId = component.attr('hs_company_id');
    $.get(`/components/advisors/road_funnel?hs_company_id=${hsCompanyId}&timeline=${timeline}`).done(function(html) {
      component.replaceWith(html);
    }).always(function() {
      // Update Road to 84 component on the page with the same timeline
      const roadTo84Dropdown = $('.advisors-road-component select[name=timeline]').first();
      if (roadTo84Dropdown.val() !== timeline) roadTo84Dropdown.val(timeline).trigger('change');
    });
  });
});